import React, { useState } from "react";
import { toast } from "sonner";
import { AlertCircle } from "lucide-react";
import { useAppDispatch, useAppSelector } from "@src/store/hooks";
import { selectSelectedInventoryItems } from "@src/store/pricing/queryEventInventoryAllSlice";
import { purchasingActions } from "@src/store";
import { Button, ButtonVariant } from "../button/Button";
import styles from "./BulkMarkInHand.module.scss";

type TBulkMarkNotInHand = {
	handleClose?: () => void;
};

const BulkMarkNotInHand = ({ handleClose }: TBulkMarkNotInHand) => {
	const dispatch = useAppDispatch();
	const items = useAppSelector(selectSelectedInventoryItems);
	const [submitting, setSubmitting] = useState(false);

	const handleConfirm = async () => {
		if (!items.length) return;
		setSubmitting(true);
		try {
			await dispatch(
				purchasingActions.updateListingInHand({
					ListingIds: items.map((x) => x.Listing_ID),
					InHand: false,
				}),
			).unwrap();
			toast.success("Marked tickets as Not In-Hand.");
			handleClose?.();
		} catch {
			toast.error("Failed to mark tickets as Not In-Hand.");
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<>
			<div className={styles.confirmRoot}>
				<div className={styles.confirmIcon}>
					<AlertCircle size={26} />
				</div>
				<div className={styles.confirmTitle}>Existing in hand settings may be overwritten.</div>
				<div className={styles.confirmText}>
					This action will remove the current In Hand status and restore the standard date-based value where
					applicable.
				</div>
			</div>
			<div className={styles.confirmButtons}>
				<Button onClick={handleClose} variant={ButtonVariant.Secondary} disabled={submitting}>
					Cancel
				</Button>
				<Button onClick={handleConfirm} isLoading={submitting} disabled={!items.length || submitting}>
					Mark not in-hand
				</Button>
			</div>
		</>
	);
};

export default BulkMarkNotInHand;
